import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import {
  getExpanded,
  getSelected,
  makeGetVisibleMailClassNodes,
} from '../redux/selectors/MailClassesSelectors';
import {
  deSelectAllMailClasses,
  mailClassExpanded,
  mailClassSelected,
  selectAllMailClasses,
} from '../redux/actions/ProductActions';

class MailCategorySelectorContainer extends Component {
  mailClassSelected = selected => this.props.mailClassSelected(this.props.mailCategory, selected);

  mailClassExpanded = expanded => this.props.mailClassExpanded(this.props.mailCategory, expanded);

  selectAll = () => this.props.selectAllMailClasses(this.props.mailCategory);

  deSelectAll = () => this.props.deSelectAllMailClasses(this.props.mailCategory);

  render() {
    if (this.props.nodes.length === 0 && this.props.selected.length) return <div />;

    return (
      <CheckboxTreeSelector
        title={this.props.description}
        nodes={this.props.nodes || []}
        expanded={this.props.expanded}
        onExpand={this.mailClassExpanded}
        expandDisabled={this.props.expandDisabled}
        onSelect={this.mailClassSelected}
        selected={this.props.selected}
        onSelectAll={this.selectAll}
        onDeSelectAll={this.deSelectAll}
      />
    );
  }
}

function makeMapStateToProps() {
  const getVisibleMailClassNodes = makeGetVisibleMailClassNodes();
  const mapStateToProps = (state, props) => ({
    nodes: getVisibleMailClassNodes(state, props),
    expanded: getExpanded(state, props),
    selected: getSelected(state, props),
  });
  return mapStateToProps;
}

const mapDispatchToProps = dispatch => bindActionCreators({
  mailClassExpanded,
  mailClassSelected,
  selectAllMailClasses,
  deSelectAllMailClasses,
}, dispatch);

MailCategorySelectorContainer.propTypes = {
  mailClassSelected: PropTypes.func,
  mailCategory: PropTypes.string,
  mailClassExpanded: PropTypes.func,
  selectAllMailClasses: PropTypes.func,
  deSelectAllMailClasses: PropTypes.func,
  description: PropTypes.string,
  nodes: PropTypes.arrayOf(PropTypes.object),
  expanded: PropTypes.arrayOf(PropTypes.string),
  expandDisabled: PropTypes.bool,
  selected: PropTypes.arrayOf(PropTypes.string),
};

export default connect(makeMapStateToProps, mapDispatchToProps)(MailCategorySelectorContainer);
